import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RichTextEditorComponent } from "../../../../../shared/rich-textEditor/rich-textEditor.component";
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@/app/environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgToastService } from 'ng-angular-popup';
import { UploadedAttachmentsComponent } from "@/app/components/global/uploaded-attachments/uploaded-attachments.component";
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { RfpLabelService } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  selector: 'app-itt-applicant-read-only-form',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInput,
    RichTextEditorComponent,
    MatIconModule,
    MatRadioModule,
    CommonModule,
    UploadedAttachmentsComponent
],
  templateUrl: './itt-applicant-read-only-form.component.html',
  styleUrl: './itt-applicant-read-only-form.component.css',
})
export class IttApplicantReadOnlyFormComponent implements OnInit, OnChanges {
  @Input() tendererResponse: any;
  @Input() isShowRfpSubmitBtn!: boolean;
  @Input() btnDisable!:boolean;
  projectId: number;
  tenderType: string;
  docUrl: string | null = null;
  experiences: any;
  projectName: string;
  projectIdentifier: string;

  sitePreparationAttachments = [];
  structuralCivilWorksAttachments = [];
  mepWorksAttachments = [];
  fitoutAttachments = [];
  healthSafetyAttachments = [];
  postConstructionAttachments = [];
  relevantExperienceAttachments = [];
  technicalProposalAttachments = [];
  cvsOfKeyPersonnelsAttachments = [];
  technicalHealthSafetyAttachments = [];
  commercialPriceBreakdownAttachments = [];
  projectProgrammeAttachments = [];
  financialStabilityAttachments = [];
  proofOfInsuranceAttachments = [];
  performanceBondsAttachments = [];
  environmentalSustainabilityPlanAttachments = [];
  technicalDeviationsClarificationsAttachments = [];
  isRFPorRFQ: string;
  labels: any;

  constructor(
    private tenderingService: TenderingService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private toast: NgToastService,
    private router: Router,
        private getFileIconService: GetFileIconUtilityService,
        private rfpLabelService: RfpLabelService
    
  ) {}

  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  
  
  
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['tendererResponse'] &&
      this.tendererResponse?.relevant_experience
    ) {
      this.experiences = JSON.parse(this.tendererResponse?.relevant_experience);
    }
    this.populateRFPTendererAttachments();
  }

  ngOnInit(): void {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
      this.isRFPorRFQ = this.rfpLabelService.updateRFPorRFQFlag(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });

    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
    });

    this.tenderingService.tenderType$.subscribe((state) => {
      this.tenderType = state;
    });    
    
  }

  downloadTendererDocument(
    event: Event,
    downloadLink: HTMLAnchorElement,
    id: number,
    filePath: string
  ): void {
    event.preventDefault(); // Prevent default anchor behavior
  
    let newTab: Window | null = null;
    if (!this.docUrl) {
      newTab = window.open('', '_blank'); // Open a blank tab first
  
      const parts = filePath.split('/');
      const _filePath = parts[parts.length - 1];
  
      const apiUrl = environment.apiUrl;
      const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/rfp/download/tenderer-documents/${id}/${_filePath}`;
  
      // Fetch the document from the backend
      this.http.get(fullPath, { responseType: 'blob' }).subscribe({
        next: (blob) => {
          this.docUrl = window.URL.createObjectURL(blob); // Convert blob to URL
  
          if (newTab) {
            newTab.location.href = this.docUrl; // Assign the blob URL to the new tab
          } else {
            window.open(this.docUrl, '_blank'); // Fallback in case tab was blocked
          }
  
          // Cleanup memory
          setTimeout(() => URL.revokeObjectURL(this.docUrl!), 5000);
        },
        error: (error) => {
          console.error('Error opening document:', error);
          newTab?.close(); // Close the tab if request fails
        },
      });
    } else {
      window.open(this.docUrl, '_blank'); // Open already downloaded doc
      this.docUrl = null;
    }
  }
  

  populateRFPTendererAttachments() {
    const attachmentMappings = [
        { key: 'site_preparation_attach', target: this.sitePreparationAttachments },
        { key: 'structure_civil_attach', target: this.structuralCivilWorksAttachments },
        { key: 'mep_work_attach', target: this.mepWorksAttachments },
        { key: 'finishing_fitout_attach', target: this.fitoutAttachments },
        { key: 'post_construction_attach', target: this.postConstructionAttachments },
        { key: 'relevant_experience_attach', target: this.relevantExperienceAttachments },
        { key: 'health_safety_attach', target: this.healthSafetyAttachments },
        { key: 'financial_stability_attach', target: this.financialStabilityAttachments },
        { key: 'proof_of_insurance_attach', target: this.proofOfInsuranceAttachments },
        { key: 'performance_bond_gurantee_attach', target: this.performanceBondsAttachments },
        { key: 'environmental_sustainability_plan_attach', target: this.environmentalSustainabilityPlanAttachments },
        { key: 'technical_deviations_clarifications_attach', target: this.technicalDeviationsClarificationsAttachments },
        { key: 'cvs_of_key_personnel_attach', target: this.cvsOfKeyPersonnelsAttachments },
        { key: 'technical_proposal_attach', target: this.technicalProposalAttachments },
        { key: 'technical_health_safety_attach', target: this.technicalHealthSafetyAttachments },
        { key: 'commercial_price_breakdown_attach', target: this.commercialPriceBreakdownAttachments },
        { key: 'project_programme_attach', target: this.projectProgrammeAttachments }
    ];

    attachmentMappings.forEach(({ key, target }) => {
        if (this.tendererResponse?.[key]) {
            this.tendererResponse[key].forEach((file) => {
                target.push({
                    id: file?.id,
                    name: file?.title,
                    path: file?.file_path,
                });
            });
        }
    });
  }

  /**
   * HTTP REQUESTS START
   */
  submitTendererResponse() {
    return this.tenderingService
      .updateRFPTendererResponseStatus(
        this.projectId,
        this.tendererResponse?.itt_id,
        this.tendererResponse?.id
      )
      .subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            if(this.isRFPorRFQ === 'RFP'){
            this.router.navigate(['/requests/rfp'],{
              queryParams:{
                projectName: this.projectName,
                projectIdentifier: this.projectIdentifier
              }
            });
          }else if(this.isRFPorRFQ === 'RFQ'){

            this.router.navigate(['/requests/rfq'],{
              queryParams:{
                projectName: this.projectName,
                projectIdentifier: this.projectIdentifier
              }
            });
          }
            this.toast.success(response?.meta?.message, 'SUCCESS', 4000);
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }

  /**
   * HTTP REQUESTS END
   */
}
